(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["svrn-product-commerce"] && !Shopify.designMode) return;
  try {
    
  if (!window.svrnProductCheckoutPrepared) {
    window.svrnProductCheckoutPrepared = true;
    document.addEventListener('click', async (event) => {
      const button = event.target instanceof Element ? event.target.closest('[data-svrn-checkout-prepare]') : null;
      if (!button || button.dataset.svrnCartReady === 'true') return;

      const form = button.closest('form');
      const variantInput = form?.querySelector('[name="id"]');
      const quantityInput = form?.querySelector('[name="quantity"]');
      const errorMessage = form?.querySelector('[data-svrn-checkout-error]');
      const label = button.querySelector('span');
      const originalLabel = label?.textContent || '';
      const variantId = Number(variantInput?.value);
      const quantity = Math.max(1, Number(quantityInput?.value || 1));
      const preparedKey = variantId ? `${variantId}:${quantity}` : '';

      if (preparedKey && button.dataset.svrnPreparedKey === preparedKey) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      if (button.dataset.svrnPreparing === 'true') return;

      if (!form || !variantId) {
        if (errorMessage) {
          errorMessage.textContent = 'Please select an available product option and try again.';
          errorMessage.hidden = false;
        }
        return;
      }

      button.dataset.svrnPreparing = 'true';
      button.setAttribute('aria-busy', 'true');
      button.disabled = true;
      if (label) label.textContent = 'Preparing checkout…';
      if (errorMessage) errorMessage.hidden = true;

      try {
        const root = window.Shopify?.routes?.root || '/';
        const addResponse = await fetch(`${root}cart/add.js`, {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ items: [{ id: variantId, quantity }] }),
        });
        const addResult = await addResponse.json();
        if (!addResponse.ok) throw new Error(addResult.description || addResult.message || 'Unable to add this item.');

        const cartResponse = await fetch(`${root}cart.js`, {
          headers: { Accept: 'application/json' },
          cache: 'no-store',
        });
        const cart = await cartResponse.json();
        if (!cartResponse.ok || !cart.item_count) throw new Error('Your cart could not be prepared. Please try again.');

        button.dataset.svrnCartReady = 'true';
        button.dataset.svrnPreparedKey = preparedKey;
        button.disabled = false;
        button.removeAttribute('aria-busy');
        if (label) label.textContent = originalLabel;
        button.click();
        delete button.dataset.svrnCartReady;
      } catch (error) {
        button.disabled = false;
        button.removeAttribute('aria-busy');
        if (label) label.textContent = originalLabel;
        if (errorMessage) {
          errorMessage.textContent = error.message || 'Checkout could not be opened. Please try again.';
          errorMessage.hidden = false;
        }
      } finally {
        delete button.dataset.svrnPreparing;
      }
    }, true);
  }

  document.querySelectorAll('[data-svrn-commerce]').forEach((section) => {
    section.querySelectorAll('[data-gallery-trigger]').forEach((trigger) => trigger.addEventListener('click', () => {
      const key = trigger.dataset.galleryTrigger;
      section.querySelectorAll('[data-gallery-panel]').forEach((panel) => panel.classList.toggle('is-active', panel.dataset.galleryPanel === key));
      section.querySelectorAll('[data-gallery-trigger]').forEach((button) => button.classList.toggle('is-active', button === trigger));
    }));
    const input = section.querySelector('input[name="quantity"]');
    section.querySelectorAll('[data-bundle-selector] input[type="radio"]').forEach((radio) => radio.addEventListener('change', () => {
      if (input) input.value = radio.value;
      section.querySelectorAll('.svrn-commerce__bundle').forEach((option) => option.classList.toggle('is-selected', option.contains(radio)));
    }));
    section.querySelector('[data-qty-minus]')?.addEventListener('click', () => { input.value = String(Math.max(1, Number(input.value || 1) - 1)); });
    section.querySelector('[data-qty-plus]')?.addEventListener('click', () => { input.value = String(Math.min(9, Number(input.value || 1) + 1)); });
    const original = section.querySelector('[data-original-cta]');
    const sticky = section.querySelector('[data-sticky-buy]');
    section.querySelector('[data-sticky-submit]')?.addEventListener('click', () => original?.click());
    if (original && sticky && 'IntersectionObserver' in window) {
      let originalPassed = false;
      let footerVisible = false;
      const renderSticky = () => sticky.classList.toggle('is-visible', originalPassed && !footerVisible);
      new IntersectionObserver(([entry]) => {
        originalPassed = !entry.isIntersecting && entry.boundingClientRect.bottom < 0;
        renderSticky();
      }, { threshold: 0 }).observe(original);
      const footer = document.querySelector('footer, #shopify-section-footer-group');
      if (footer) new IntersectionObserver(([entry]) => {
        footerVisible = entry.isIntersecting;
        renderSticky();
      }, { threshold: 0 }).observe(footer);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["svrn-video-stories"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-svrn-motion]').forEach((section) => {
    const videos = [...section.querySelectorAll('video')];
    if (!('IntersectionObserver' in window)) return;
    const observer = new IntersectionObserver((entries) => entries.forEach((entry) => {
      const video = entry.target;
      if (entry.isIntersecting && entry.intersectionRatio > .72) {
        videos.forEach((item) => { if (item !== video) item.pause(); });
        video.muted = true;
        video.play().catch(() => {});
      } else video.pause();
    }), { threshold: [.25, .72] });
    videos.forEach((video) => observer.observe(video));
  });

  } catch(e) { console.error(e); }
})();
})();
